exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "#password-expiry-modal.modal {\n  background: #f2f4f8; }\n  #password-expiry-modal.modal .modal-content {\n    background: #0a73b8;\n    color: white; }\n\n.center {\n  text-align: center; }\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// /Users/sensorflow/Documents/legacy/kalinda/Dashboard/sensorflow-dashboard/src/app/core/simple-modal/simple-modal.component.scss
// module id = ../../../../../src/app/core/simple-modal/simple-modal.component.scss
// module chunks = main